// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Vla-z"};